<template>
  <div class="main-container">
    <page-header>{{'我的同行人' | dealLanguage('Traveling Companion')}}</page-header>
    <div class="flex-wrapper">
      <div class="flex-left">
        <user-info-nav></user-info-nav>
      </div>
      <div class="flex-right">
        <div class="view-title">
          <div class="title">{{'我的同行人' | dealLanguage('Traveling Companion')}}</div>
          <div class="line"></div>
          <div class="button" @click="addCompanions">{{'添加同行人' | dealLanguage('Add')}}</div>
        </div>
        <Table :columns="columns" :data="data" :loading="loading" :no-data-text="language == 'zh' ? '暂无数据' : 'Nodata'">
          <template slot="mobile" slot-scope="{ row }">
            <div>
              <p>+{{row.mobileAreaCode}}{{row.mobile}}</p>
            </div>
          </template>
          <template slot="action" slot-scope="{ row }">
            <div><Button type="text" @click="delPartner(row.id)">{{'删除' | dealLanguage('Delete')}}</Button></div>
          </template>
        </Table>
        <div class="page clear" v-if="total > 20">
          <Page :total="total" :current="page" :page-size="20" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import UserInfoNav from '@/components/pc/userInfoNav.vue'
import { getPartnerList, modifyPartner, delPartner } from '@/service/vbef'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '我的同行人' : 'Traveling Companion', 
    }
  },
  data() {
    return {
      // columns: [
      //   {
      //     key: 'name',
      //     title: this.language == 'zh' ? '姓名' : 'Name',
      //   },
      //   {
      //     slot: 'mobile',
      //     title: this.language == 'zh' ? '手机' :'Phone Number',
      //   },
      //   {
      //     key: 'compName',
      //     title: this.language == 'zh' ? '公司' : 'Company'
      //   },
      //   {
      //     key: 'department',
      //     title: this.language == 'zh' ? '部门' : 'Department',
      //   },
      //   {
      //     key: 'title',
      //     title: this.language == 'zh' ? '职位' : 'Position',
      //   },
      //   {
      //     title: ' ',
      //     slot: 'action',
      //   },
      // ],
      data: [],
      page: 1,
      size: 20,
      total: 0,
      loading: false,
    }
  },

  components: {
    PageHeader,
    UserInfoNav,
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
    columns() {
      return (
          [
          {
            key: 'name',
            title: this.language == 'zh' ? '姓名' : 'Name',
          },
          {
            slot: 'mobile',
            title: this.language == 'zh' ? '手机' :'Phone Number',
          },
          {
            key: 'compName',
            title: this.language == 'zh' ? '公司' : 'Company'
          },
          {
            key: 'department',
            title: this.language == 'zh' ? '部门' : 'Department',
          },
          {
            key: 'title',
            title: this.language == 'zh' ? '职位' : 'Position',
          },
          {
            title: ' ',
            slot: 'action',
          },
        ]
      )
    }
  },

  created() {
    this.getPartnerList()
  },

  mounted() {},

  methods: {
    addCompanions() {
      this.$router.push({
        name: 'addCompanions',
      })
    },
    async getPartnerList() {
      this.loading = true
      let res = await getPartnerList({
        page: this.page,
        size: this.size,
      })
      if (res.code == 0) {
        this.$set(this, 'data', res.data.partner)
        this.total = res.data.count
      }
      this.loading = false
    },
    async delPartner(id) {
      console.log(id);
      let res = await delPartner({
        id: id
      })
      if(res.code == 0) {
        this.getPartnerList()
      } else {
        this.$Message.error(this.language == 'zh' ? '删除失败' : 'Delete failed')
      }
    },
    handleChangePage(val) {
      this.page = val
      this.getPartnerList()
    }
  }
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.flex-right
  .view-title
    display flex
    align-items center
    margin-bottom 10px
    .title
      font-size 14px
      font-weight 600
      color #333333
      line-height 20px
      margin-right 10px
    .line
      flex auto
      border-top 1px solid #EEEEEE
    .button
      // width 120px
      padding 0 20px
      height 40px
      background #FF8824
      border-radius 4px
      cursor pointer
      border 1px solid #FF8824
      transition all 0.5s
      margin-left 20px
      font-size 16px
      color #FFFFFF
      line-height 40px
      text-align center
      &:hover
        background-color #F60
        border-color #F60
  >>>.ivu-table-wrapper
    .ivu-table-header
      th
        background-color #FFFAF5
        padding 15px 0
        border none
        .ivu-table-cell
          span
            color #3D3D3D !important
            font-size 14px !important
            font-weight 400 !important
  .page
    margin-top 18px
    margin-bottom 30px
>>>.ivu-btn-text
  color #1572E7
  &:hover
    background-color unset !important
</style>
